

























import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
    components: {

    }
}) export default class ManualContents extends Mixins(VueHoduCommon) {

    mounted() : void {

    }

    /**
     * 매뉴얼 탭 변경
     */
    changeMaunalTab(tab : string) : void {
        this.doSetManualTab(tab);
    }
    
    /**
     * 매뉴얼 다운로드 & 열기
     */
    manualDownloadAndOpen() : void {
        this.$http({
            url : 'app_images/hodu_manual.pdf',
            method : 'GET',
            responseType: 'blob'
        }).then(async(response) => {
            const blob = new Blob([response.data], { "type" : "application/pdf" });

            if ( window.navigator && window.navigator.msSaveOrOpenBlob ) {
                window.navigator.msSaveOrOpenBlob(blob, "hodu_manual.pdf"); // for IE
                return;
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'hodu_manual.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            let newWin = window.open(url);
            if( newWin == null ) return;
            newWin.focus();
        })
        .catch((e) => {
            alert("파일 다운로드 실패");
        });
    }

}

